/*
 * CHI-20 mount point for Bravo CHI-23's EditGuest (CHI-20-seams.md,
 * touchpoints-bravo-dev3.md). Dev3 builds no edit logic and never calls
 * ticketGuests.update.
 *
 * Optional import: Vite's import.meta.glob resolves to {} when
 * client/src/components/tickets/EditGuest.tsx is absent, so this patch stands
 * alone (renders nothing) and Bravo's component mounts automatically once its
 * patch is applied. No code from Bravo is vendored here.
 *
 * TicketQrCard renders this only before the event starts (server-offset clock).
 */
import { lazy, Suspense, type ComponentType } from "react";

/** Matches Bravo's EditGuestProps (feat/chi-23-guest-edit @ 64979e7). */
export type EditGuestSlotProps = {
  ticketId: number;
  guestName: string;
  guestEmail: string | null;
  /** Fired by EditGuest after a successful ticketGuests.update; refetches myTickets. */
  onGuestUpdated: () => void;
};

const modules = import.meta.glob<{ default: ComponentType<EditGuestSlotProps> }>("./EditGuest.tsx");
const loader = modules["./EditGuest.tsx"];
const EditGuest = loader ? lazy(loader) : null;

export const EDIT_GUEST_AVAILABLE = Boolean(EditGuest);

export default function EditGuestSlot(props: EditGuestSlotProps) {
  if (!EditGuest) return null;
  return (
    <Suspense fallback={null}>
      <EditGuest {...props} />
    </Suspense>
  );
}
